/**
 * COPY of ../scss/variables.scss - always copy from there into here.
 * Purpose: to expose variables.scss theme variables to js, so that
 * they can be applied to js runtime themes & colors
 */
/**
 * Ori colors
 */
export const Ori = {
    white: '#ffffff',
    darkWhite: '#f2f2f2',
    darkerGray: '#333333',
    darkGray: '#4a4a4a',
    lightGray: '#cccccc',
    purple: '#933b77',
    darkerPurple: '#803367',
};

/*
 * Bootstrap colors
 */
export const Bootstrap = {
    primary: '#007bff',
    secondary: '#6c757d',
    success: '#28a745',
    danger: '#dc3545',
    warning: '#ffc107',
    info: '#17a2b8',
    light: '#f8f9fa',
    dark: '#343a40',
};

/**
 * features
 */
export const Features = {
    borderRadius: '.3em',
};
